import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getBalance = createAsyncThunk(
  "student/getBalance",
  async ({userFilter,typeFilter }, { rejectWithValue }) => { 
    try {
      let url = `/balance/all`;
      if (userFilter) {
        url += `?userFilter=${userFilter}`;
      }
      if (typeFilter) {
        url += `&typeFilter=${typeFilter}`;
      }
      const response = await apiInstance.get(url, {
        headers: authHeader(),
      });
      return response;  
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getTransaction = createAsyncThunk(
  "student/getTransaction",
  async ({page, limit,transactionStatusFilter }, { rejectWithValue }) => { 
    try {
      let url = `/transaction/all?page=${page}&limit=${limit}`;
      if (transactionStatusFilter) {
        url += `&transactionStatusFilter=${transactionStatusFilter}`;
      }
      const response = await apiInstance.get(url, {
        headers: authHeader(),
      });
      return response;  
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  balanceData: null,
  transactionData:null
};

const balanceSlice = createSlice({
  name: "balanceSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBalance.fulfilled, (state, action) => {
        state.balanceData = action.payload.data;
      })
    builder
      .addCase(getTransaction.fulfilled, (state, action) => {
        state.transactionData = action.payload.data;
      })
  },
});

export default balanceSlice.reducer;
